<template>
  <view-with-bar>
    <template slot="bar">
      <view-bar>
        <div style="background-color: red;">

        </div>
        <h1>{{ $t("processing.processes")}}</h1>
        <view-bar-item route="/processing/processes">{{ $t("processing.processesHistory")}}</view-bar-item>
        <view-bar-item route="/processing/files">{{ $t("processing.uploadedFiles")}}</view-bar-item>
        <view-bar-item route="/processing/mappings">{{ $t("processing.mappings")}}</view-bar-item>
        <h1>{{ $t("processing.scheduling")}}</h1>
        <view-bar-item route="/processing/scheduled-jobs">{{ $t("processing.scheduledJobs")}}</view-bar-item>
        <h1>{{ $t("processing.scripting")}}</h1>
        <view-bar-item route="/processing/definitions">{{ $t("processing.scripts")}}</view-bar-item>

      </view-bar>
    </template>
  </view-with-bar>
</template>

<script>
import ViewWithBar from "../components/layout/ViewWithBar";
import ViewBarItem from "../components/navigation/ViewBarItem";
import ViewBar from "../components/navigation/ViewBar";

export default {
  name: "ProcessingView",
  components: {ViewBar, ViewBarItem, ViewWithBar}
}
</script>

<style scoped>

</style>